import { render, staticRenderFns } from "./VersionContent.vue?vue&type=template&id=71c360fc&scoped=true"
import script from "./VersionContent.vue?vue&type=script&lang=js"
export * from "./VersionContent.vue?vue&type=script&lang=js"
import style0 from "./VersionContent.vue?vue&type=style&index=0&id=71c360fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c360fc",
  null
  
)

export default component.exports